<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="justify-end align-end text-end">
        <v-btn color="success" @click="showModal">
          <v-icon class="white--text">mdi-plus</v-icon>
          Create Call Campaign
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-dialog v-model="dialog" width="600">
        <call-campaign-form/>
      </v-dialog>
    </v-row>
    <v-row>
      <v-col cols="12">
        <table-widget title="Call Campaigns" :headers="headers" :table-row-data="sms"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TableWidget from "@/components/widgets/tables/TableWidget";
import SmsCampaignForm from "@/components/widgets/forms/smsCampaignForm";
import {getRequest} from "@/api/apirepository";
import CallCampaignForm from "@/components/widgets/forms/callCampaignForm";

export default {
  metaInfo: {
    title: 'Call Center',
  },
  name: "CallCenter",
  components: {CallCampaignForm, SmsCampaignForm, TableWidget},
  data() {
    return {
      headers: [
        {
          text: 'Electoral Region',
          align: 'left',
          sortable: true,
          value: 'orderRef',
        },
        {text: 'Constituents', value: 'vehicle'},
        {text: 'Calls', value: 'fueltype'},
        {text: 'Received', value: 'fueltype'},
        {text: 'Not Reachable', value: 'fueltype'},
        {text: 'Hang up', value: 'fueltype'},
        {text: 'Cost', value: 'volume'},
        {text: 'Actions', value: 'action'}
      ],
      sms: [],
      dialog: false,
    }
  },
  methods: {
    showModal() {
      this.dialog = true;
    },
    getSMSCampaigns() {
      getRequest('callPoll').then(({data}) => {
        this.sms = data;
      }).catch(e => {
        console.log(e)
      })
    }
  },
  created() {
    this.getSMSCampaigns()
  }
}
</script>

<style scoped>

</style>